import React from 'react'
import { CircularProgress } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMessage } from '@fortawesome/pro-regular-svg-icons'
import { formatCompactTime } from '../../../utils/dates'
import { useStyles } from './ChatHistoryRow.styles'

interface ChatHistoryRowProps {
  title: string
  /** ISO-8601 last-activity time; shown as a compact label on the right. */
  updatedAt: string
  /** This row's session is being loaded — spinner in place of the time. */
  isLoading: boolean
  /** Another row is loading — block clicks but don't show this row's spinner. */
  disabled: boolean
  onSelect: () => void
}

const ChatHistoryRowComponent: React.FC<ChatHistoryRowProps> = ({
  title,
  updatedAt,
  isLoading,
  disabled,
  onSelect,
}) => {
  const { classes } = useStyles()

  return (
    <button
      className={classes.row}
      type="button"
      onClick={onSelect}
      disabled={disabled || isLoading}
    >
      <span className={classes.iconTile}>
        <FontAwesomeIcon icon={faMessage} />
      </span>
      <span className={classes.title} title={title}>
        {title}
      </span>
      {isLoading ? (
        <CircularProgress size={14} thickness={5} />
      ) : (
        <span className={classes.time}>{formatCompactTime(updatedAt)}</span>
      )}
    </button>
  )
}

export const ChatHistoryRow = React.memo(ChatHistoryRowComponent)
